// Summary: This page will display a list of samples. The user can click on a sample to go to the Sample Details page for that sample.
// 
// This page will display a list of samples. The user can click on a sample to go to the Sample Details page for that sample.
//


// import React, { useRef, useEffect, useMemo, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';

import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Ripple } from 'primereact/ripple';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

// import axios from "axios"

import classNames from 'classnames';
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext";
// import { set } from "d3v4";

// PrimeReact imports
import { Toast } from 'primereact/toast';
// import { Steps } from 'primereact/steps';
// import { Button } from 'primereact/button';
// import { InputText } from 'primereact/inputtext';
// import { DataTable } from 'primereact/datatable';
// import { Column } from "primereact/column";


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

function SampleList() {

    const location = useLocation();
    const navigate = useNavigate(); 


    const [loading, setLoading] = useState(false)
    const [samples, setSamples] = useState([]);
    const [columns, setColumns] = useState([]);
    const [samplesChecked, setSamplesChecked] = useState({});
    const [createDatasetVisible, setCreateDatasetVisible] = useState(false);
    const [datasetName, setDatasetName] = useState('');
    const [datasetPublic, setDatasetPublic] = useState(false);

    const toast = useRef(null);

    let samples_temp = [];
    let loadSampleData = true

    const navigateToSampleDetail = (sample_name, sample_id) =>{ 
        // const path = "manage_sample/new_sample/upload-csv" ; 
        const path = "/datasets/sample_details" ; 
        navigate(path,{
            state:{
                id:sample_id,
                name:sample_name
            }
        })
      }

      useEffect(() => {

        // setColumns([]);

        // if (samples && columns.length === 0) {
        if (samples && samples.length > 0) {
            const mySet = new Set();


            
            samples.forEach((sample) => {
                // let index = 0;
                // item.files.forEach((file) => {
                //     index += 1;
                //     mySet.add(`file${index}`);
                // });

                // item.sampleattributes.forEach((attr) => {
                //     mySet.add(attr.name);
                // });

                // console.log("sample",sample)
                Object.keys(sample).forEach((key) => {
                    mySet.add(key);
                });
            });

            // console.log("mySet",mySet)

            setColumns([]);

            mySet.forEach((item) => {
                // If the column is on of: id, sample, date, file1, file2 -> skip it
                if ( item.toLowerCase() === 'files' ||
                        item.toLowerCase() === 'sampleattributes' ||
                        item.toLowerCase() === 'samplegroups' ||
                        item.toLowerCase() === 'groupid' ||
                        item.toLowerCase() === 'ownerid' ||
                        item.toLowerCase() === 'id' || 
                        item.toLowerCase() === 'sample' || 
                        item.toLowerCase() === 'name' || 
                        item.toLowerCase() === '"createdat"' || 
                        item.toLowerCase() === 'file1' || 
                        item.toLowerCase() === 'file2'
                    ) {
                    return;
                }
                // Add the remaining columns to the columns array
                setColumns(columns => [...columns, {field: item.trim(), header: item.trim().toUpperCase()}]);
            });
        }
    // }, [samples, columns.length]);
    }, [samples]);

    // console.log("columns",columns)
    // console.log("samples",samples)

    useEffect(() => {
        const session_sampleids = getSessionStorageOrDefault('sampleids', null);

        // If we pass in sampleids, we should load those samples
        if (loadSampleData && samples.length === 0 && location.state && location.state.sampleids && location.state.sampleids.length > 0) {
            // If we pass in sampleids, we should load those samples
            console.log("location.state.sampleids",location.state.sampleids)
            loadSampleData = false;
            setSamples([]);
            getSampleData(location.state.sampleids);
        } 
        // else if (loadSampleData && samples.length === 0) {
            else if (loadSampleData && session_sampleids && session_sampleids.length !== 0) {
            // If we have sampleids in session storage, load those samples
            console.log("session_sampleids",session_sampleids)
            loadSampleData = false;
            setSamples([]);
            getSampleData(session_sampleids);
        } else {
            // If we already have samples, don't load them again
            loadSampleData = false;
        }

    }, [, location.state]);

    useEffect(() => {
        document.title = `Data -> List Samples | Palmona Pathogenomics`
    }, []);


    const formatDate = (value) => {
        return value.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    async function getAllSampleData() {

        console.log("getAllSampleData")
        // const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
        // const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        // const headers = {
        //     'Content-Type': 'multipart/form-data',
        //     Authorization: `Bearer ${getDataUserToken}`,
        // };

        // axios.get( 
        //     `${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample?userId=${getDataUserId}`, {
        //         headers,
        // }).then((response) => {

        //     console.log("response",response.data)

        //     setSamples(response.data);
            
        // }).catch((error) => {
        //     console.error("err from post dataset",error)
        // });

    }
    

    async function getSampleData(sampleids) {
        const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const headers = {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${getDataUserToken}`,
        };
        
        if ( sampleids ) {
            samples_temp = [];

            const newSamplesChecked = {};
            sampleids.forEach(sampleid => {
                newSamplesChecked[sampleid] = true;
            });
            setSamplesChecked(newSamplesChecked);

            sampleids.forEach( async (sampleid) => {
                const post_response = await fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample/${sampleid}?userId=${getDataUserId}`, 
                    {
                        method: 'GET',
                        headers: headers
                    });
                    
                    const data = await post_response.json();

                    let index = 0;
                    data.files.forEach((file) => {
                        index += 1;
                        data[`file${index}`] = file.name;
                    });

                    data.sampleattributes.forEach((attribute) => {
                        data[attribute.name.toLowerCase()] = attribute.value.toLowerCase();
                    });

                    setSamples(samples => [...samples, data]);

            });

            sessionStorage.setItem('sampleids', JSON.stringify(sampleids));
        } 
    } 


    const [activeTab, setActiveTab] = useState(0);

    // setActiveTab(2);

    const dateBodyTemplate = (sample) => {
        return formatDate(Date.parse(sample.createdAt));
    };


    const idBodyTemplate = (sample) => {
        return (
            <div className="flex flex-row align-items-center">
                <Checkbox checked={samplesChecked[sample.id]} onChange={e => {
                    const newSamplesChecked = {...samplesChecked};
                    newSamplesChecked[sample.id] = e.checked;
                    setSamplesChecked(newSamplesChecked);
                }}/>
                <a onClick={() => navigateToSampleDetail(sample.name, sample.id)}
                    className={classNames('p-ripple flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-indigo-400 border-round text-indigo-100 hover:text-indigo-50 transition-duration-150 transition-colors', { 'bg-indigo-700': activeTab === 0 })}>
                    <i className="pi pi-file-edit text-lg pr-2"></i>{sample.id}
                    <Ripple />
                </a>
            </div> 
        );
    };

    const [visible5, setVisible5] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [columnsRowClick, setColumnsRowClick] = useState(true);

    const createDataset = () => {
        // create new dataset
        const body = new FormData();
        body.append('name', datasetName);
        body.append('ownerId', getSessionStorageOrDefault('userid'));
        body.append('groupId', getSessionStorageOrDefault('usergroups'));
        body.append('public', datasetPublic);

        const userToken = JSON.parse(sessionStorage.getItem('apitoken'));
        const headers = {
            Authorization: `Bearer ${userToken}`,
        };

        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset`, {
            method: 'POST',
            headers,
            body
        })
            .then(res => res.json())
            .then(dataset => {
                Object.entries(samplesChecked).forEach(([sampleId, included]) => {
                    if (included) {
                        const sampleBody = new FormData();
                        sampleBody.append('userId', getSessionStorageOrDefault('userid'));
                        sampleBody.append('sampleId', sampleId);
                        fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${dataset.id}`, {
                            method: 'PATCH',
                            headers,
                            body: sampleBody
                        })
                            .catch(err => console.error(err))
                    }
                })
            })
            .then(toast.current.show({severity:'success', summary: 'Success', detail:'New dataset created', life: 3000}))
            .catch(err => console.error(err));

        setCreateDatasetVisible(false);
        setDatasetName('');
    }

    return (
        <main className='add-csv mt-2'>
            {/* Column Selection Dialog */}
            <Toast ref={toast} />
            <Dialog
                visible={visible5}
                onHide={() => setVisible5(false)}
                modal
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                header={
                    <div className="flex flex-column gap-2">
                        <h1 className="m-0 text-900 font-semibold text-xl line-height-3">Show Attitional Attribute Columns</h1>
                        <span className="text-600 text-base font-normal">Select Attribute Fields below for display.</span>
                    </div>
                }
                footer={
                    <div className="flex gap-3 justify-content-end border-top-1 surface-border pt-5">
                        <Button label="Cancel" onClick={() => setVisible5(false)} className="p-button-text"></Button>
                        <Button label="Show Attributes" onClick={() => setVisible5(false)} className="p-button-rounded"></Button>
                    </div>
                }
                style={{ width: '52vw' }}
                draggable={false}
                resizable={false}>
                <form className="flex flex-column gap-3 mt-3">
                    <div>
                        <label htmlFor="attributename" className="block mb-1 text-color text-base">
                            Attribute Name
                        </label>
                        <span className="p-input-icon-left w-full">
                            <DataTable 
                                value={columns} 
                                selectionMode={columnsRowClick ? null : 'checkbox'} 
                                selection={selectedColumns} 
                                onSelectionChange={(e) => setSelectedColumns(e.value)} 
                                dataKey="field" 
                                id="attributename"
                                tableStyle={{ minWidth: '40rem' }}>
                                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                    <Column field="field" header="Field" headerStyle={{ width: '3rem' }}></Column>
                            </DataTable>
                        </span>
                    </div>
                </form>
            </Dialog>
            {/* End of Column Selection Dialog */}

            <Dialog
                visible={createDatasetVisible}
                onHide={() => setCreateDatasetVisible(false)}
                modal
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                header={
                    <div className="flex flex-column gap-2">
                        <h1 className="m-0 text-900 font-semibold text-xl line-height-3">Dataset Name</h1>
                    </div>
                }
                footer={
                    <div className="flex gap-3 justify-content-end border-top-1 surface-border pt-5">
                        <Button label="Submit" onClick={createDataset} className="p-button-rounded"></Button>
                    </div>
                }
                style={{ width: '30vw' }}
                draggable={false}
                resizable={false}>
                <div className="flex flex-column">
                    <InputText value={datasetName} onChange={e => setDatasetName(e.target.value)}/>
                    <div className="m-3">
                        <Checkbox checked={datasetPublic} onChange={e => setDatasetPublic(e.checked)}/>
                        <label>Public</label>
                    </div>     
                </div>
            </Dialog>



            <div className=''>
                <div className='row'>
                    <div className='col-10'>
                        <div>
                            <h5>Samples List</h5>
                            <p>This is a list of recently created Samples.</p>
                            <p>Click on any Sample ID in the list to go to the <strong>Sample Details</strong> page for that Sample.</p>
                            <p>On the Sample Detals page you will be able to add <strong>Files</strong> and <strong>Attributes</strong> to the Sample.</p>
                        </div>

                        <div className='m-3'>
                            <div className='mb-2'>
                                <Button className="pi pi-eye mr-2" label="Select Columns" onClick={() => setVisible5(true)} ></Button>
                            </div>
                        </div>
                        <div className="card mt-4" >
                            <DataTable 
                                value={samples} 
                                tableStyle={{ minWidth: '50rem' }}
                                loading={loading}
                                emptyMessage="No samples found."
                            >
                                <Column field="id" header="Sample ID" body={idBodyTemplate}></Column>
                                <Column field="name" header="Name"></Column>
                                <Column field="file1" header="File1"></Column>
                                <Column field="file2" header="File2"></Column>
                                <Column field="createdAt" header="Creation Date" dataType="date"></Column>

                                { selectedColumns.map((col, i) => (
                                    <Column key={col.field.toLowerCase()} field={col.field.toLowerCase()} header={col.header} style={{ minWidth: '12rem' }} />  // filter filterPlaceholder='Search by ' />
                                ))}
                            </DataTable>
                        </div>
                        <div className='m-3'>
                            <div className='mb-2'>
                                <Button className="mr-2" label="Create Dataset from Selected Samples" onClick={() => setCreateDatasetVisible(true)} ></Button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    );
}

export default SampleList;